import { render } from "./insurancetemplatetitles.vue?vue&type=template&id=c6e06298&scoped=true"
import script from "./insurancetemplatetitles.vue?vue&type=script&lang=js"
export * from "./insurancetemplatetitles.vue?vue&type=script&lang=js"

import "./insurancetemplatetitles.vue?vue&type=style&index=0&id=c6e06298&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e06298"]])

export default __exports__